import { render, staticRenderFns } from "./product-carousel.vue?vue&type=template&id=57b3eb9a&scoped=true&"
import script from "./product-carousel.vue?vue&type=script&lang=js&"
export * from "./product-carousel.vue?vue&type=script&lang=js&"
import style0 from "./product-carousel.vue?vue&type=style&index=0&id=57b3eb9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b3eb9a",
  null
  
)

export default component.exports